module.exports = __webpack_public_path__ + "static/nola_header-a3095d2866a57225f999ca630f7dcc3e.jpg";